import * as React from "react";
import { makeStyles, Text } from "@fluentui/react-components";

const useStyles = makeStyles({
  footer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    padding: "8px 16px",
    borderTop: "1px dashed var(--border-primary, #E0E2E6)",
  },
  dot: {
    width: "3px",
    height: "3px",
    borderRadius: "50%",
    backgroundColor: "var(--text-tertiary, #6E747D)",
  },
});

/**
 * Telemetry footer — latency, tokens, cache indicator.
 * @param {{ telemetry: { latencyMs?: number, tokens?: number, cached?: boolean, clientLatencyMs?: number } | null }} props
 */
const TelemetryFooter = ({ telemetry }) => {
  const styles = useStyles();
  if (!telemetry) return null;

  const latency = telemetry.clientLatencyMs || telemetry.latencyMs;
  const parts = [];

  if (latency) parts.push(`${(latency / 1000).toFixed(1)}s`);
  if (telemetry.tokens) parts.push(`${telemetry.tokens.toLocaleString()} tokens`);
  if (telemetry.cached) parts.push("Cached");

  if (parts.length === 0) return null;

  return (
    <div className={styles.footer}>
      {parts.map((part, i) => (
        <React.Fragment key={i}>
          {i > 0 && <span className={styles.dot} />}
          <Text size={200} style={{ color: "var(--text-tertiary, #6E747D)" }}>
            {part}
          </Text>
        </React.Fragment>
      ))}
    </div>
  );
};

export default TelemetryFooter;
